import { render, staticRenderFns } from "./digital.vue?vue&type=template&id=12440b7d&lang=html&"
import script from "./digital.vue?vue&type=script&lang=js&"
export * from "./digital.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/service.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "digital.vue"
export default component.exports